// extracted by extract-css-chunks-webpack-plugin
module.exports = {"text":"text-2jfyZjAu"};